import React from "react";
import '../styles/BannerCalculatorTwo.css'

const BannerCalculatorTwo = ({ data }) => {
    
    return(
        <section className={`${data.class} xs:p-4`}>
            <img src={data.image} alt="logo" className="mx-auto pt-8 xs:h-16"/>
            <h1>{data.title}</h1>
            <h3>{data.text}</h3>
        </section>

    );
};

export default BannerCalculatorTwo; 